import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '@pkg/assets/logotypes/full.svg';
import { ReactComponent as LogoSymbol } from '@pkg/assets/logotypes/hand.svg';
import { normalizeUrl } from '@pkg/utils';

import config from '@app/config';

import './_LogoLink.scss';

interface LogoLinkProps {
    symbolOnly?: boolean;
    classes?: string;
}

const href = normalizeUrl(config.publicUrl).href;

export const LogoLink = ({ symbolOnly = false, classes }: LogoLinkProps) => {
    const { t } = useTranslation(['words', 'common']);

    const classNames = useMemo(() => {
        const classNames: string[] = ['logo-link'];
        if (classes) classNames.push(classes);
        return classNames.join(' ');
    }, [classes]);

    return (
        <a href={href} className={classNames} aria-label={t('homepage')}>
            {symbolOnly ? (
                <LogoSymbol className="logo-link__svg" aria-hidden="true" />
            ) : (
                <Logo className="logo-link__svg" aria-hidden="true" />
            )}
        </a>
    );
};
